import { PropsWithClassName } from "@models/types/index";
import type { PropsWithChildren } from "react";
import classNames from "classnames";
import { CountDown } from "@components/molecules/count-down/index.client";
import { useAtom } from "jotai";
import { showCountdownAtom } from "@models/state/count-down";

interface Props extends PropsWithChildren, PropsWithClassName {}

export function HeaderLayout({
  children,
  className,
}: Props) {
  const [showCountdown, _] = useAtom(showCountdownAtom);
  return (
    <>
      <CountDown />
      <div className="h-[80px] invisible" />
      <header
        
        className={classNames(
          "bg-white top-0 w-full z-40 h-[100px] max-w-full px-4 sm:px-6 max-auto",
          {
            sticky: showCountdown,
            fixed: !showCountdown,
          }
        )}
      >
        <div
          className={classNames(
            "flex h-full items-center justify-between border-b-2 border-gray-100 lg:justify-start lg:space-x-10",
            className
          )}
        >
          {children}
        </div>
      </header>
    </>
  );
}
